import { mount, unmount } from 'svelte';

export default class Router {
    constructor(options) {
      this.options = options;
      this.component = null;
      this.matchRoute = this.matchRoute.bind(this);
      this.matchRoute(window.location);
    }
  
    findGetParameter(parameterName) {
      var result = null,
        tmp = [];
      location.search
        .substr(1)
        .split("&")
        .forEach(function(item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
      return result;
    }
  
    matchRoute() {
      try {
        let location = window.location;
  
        let isDebug = this.findGetParameter("debug") == "true" ? true : false;
        if (isDebug) {
          alert("Directing to: " + location);
        }
    
        if (this.component) unmount(this.component);
  
        // login user
        let user = null;
        const json = localStorage.getItem("chaletapp-login");
        if (json && json !== "undefined") {
          user = JSON.parse(json);
        }
  
        // @todo handle user login expiry
        if (user && user.expiry <= new Date().getTime()) {
          console.log("User is expired; redirecting to login.")
          localStorage.setItem("chaletapp-login", null);
          window.location.assign("#login");
        }
  
        let hash = window.location.hash;
        if (hash == "#login") {
          hash = "#home";
        }
  
        if (!user && (hash !== "#offline")) { // PWA users are #offline
            this.component = mount(this.options.routes["#login"], {
              target: document.body,
              props: {
                redirectTo: hash
              }
            });
            if (window.location.hash !== "#login") {
              window.location.assign("#login");
            }
            return this.component;
        }
    
        for (let path in this.options.routes) {
          if (!Object.prototype.hasOwnProperty.call(this.options.routes, path)) {
            continue;
          }
          if (path !== hash) {
            continue;
          }
          this.component = mount(this.options.routes[hash], {
            target: document.body
          });
          return this.component;
        }
    
        /** if no route matches, display 404 **/
        this.component = mount(this.options.routes["#404"], {
          target: document.body
        });
        return this.component;
      } catch(error) {
        console.error(error);
        window.location.assign("#500");
        this.component = mount(this.options.routes["#500"], {
          target: document.body,
          props: {
            message: error
          }
        });
        return this.component;
      }
    }
  }
  